import { create } from 'zustand';

import { CategoryTreeItem } from '~apis/categories';

import { TreeData } from '../types';

interface Store {
  categoryTree: TreeData<CategoryTreeItem>[];
  setCategoryLabelTree: (data: TreeData<CategoryTreeItem>[]) => void;
}

const initialState: Omit<Store, 'setCategoryLabelTree'> = {
  categoryTree: [],
};

const useCategoryLabelTreeStore = create<Store>((set) => ({
  ...initialState,
  setCategoryLabelTree: (data) => set({ categoryTree: data }),
}));

export default useCategoryLabelTreeStore;
